import { List, Create, Edit, Home } from "../Components/index.js";

export default [
    {
        path: "/store/dashboard/home/list",
        component: Home,
        name: "store.dashboard.list",
        meta: {
            requiresAuth: true,
        },
    },
];
